import { createSelector } from '@ngrx/store';
import { getCustomQuestionsState as state } from '../reducers';
import { CustomQuestionsState } from './custom-questions.reducers';

export const getSaveAnswersActionState = createSelector(
  state,
  (state: CustomQuestionsState) => state.saveAnswersActionState
);
export const getCustomQuestionActionState = createSelector(
  state,
  (state: CustomQuestionsState) => state.customQuestionsActionState
);
export const isCustomQuestionLoading = createSelector(
  state,
  (state: CustomQuestionsState) =>
    state.customQuestionsActionState.pending &&
    !state.customQuestionsActionState.done
);
export const getCustomQuestionLoading = createSelector(
  getCustomQuestionActionState,
  actionState => actionState.pending
);
export const getCustomQuestionErrorMessage = createSelector(
  getCustomQuestionActionState,
  actionState => actionState.error?.message
);
export const getCustomQuestionsByProperty = createSelector(
  state,
  (state: CustomQuestionsState) => state.customQuestions
);
export const getHierarchicalQuestionsByProperty = createSelector(
  state,
  (state: CustomQuestionsState) => state.hierarchicalRootQuestions
);
export const isHierarchicalQuestionsModalOpen = createSelector(
  state,
  (state: CustomQuestionsState) => state.isModalOpen
);
export const getCustomerQuestionsAndAnswers = createSelector(
  state,
  (state: CustomQuestionsState) => state.customerQuestions
);
